import type { TrackingHeadersModel } from '@develop/ia-api-library'
import { defineStore } from 'pinia'

export const useDeviceInfo = defineStore('devices', () => {
  const deviceData = useDevice()
  const userAgent = deviceData.userAgent || ''

  const devicePattern = /(\w+?);/
  const deviceMatch = userAgent.match(devicePattern)
  const deviceInfo = deviceMatch ? deviceMatch[1] : (deviceData.isMobile ? 'Mobile' : deviceData.isTablet ? 'Tablet' : 'Desktop')

  const browserPattern = /(Firefox|Chrome|Safari|Edge|Opera|MSIE|Trident)/
  const browserMatch = userAgent.match(browserPattern)
  const browserInfo = browserMatch ? browserMatch[0] : 'Unknown'

  const systemVersionPattern = /(Windows NT|Mac OS X|Android|iPhone OS|iPad OS|Linux)[\s/]?([\d._]*)/
  const systemVersionMatch = userAgent.match(systemVersionPattern)
  const systemType = systemVersionMatch ? systemVersionMatch[1] : 'Unknown'
  const systemVersion = systemVersionMatch ? systemVersionMatch[2] : 'Unknown'

  const trackingHeaders = {
    'X-Device': deviceInfo,
    'X-Browser': browserInfo,
    'X-System': systemType,
    'X-System-Version': systemVersion,
  } as TrackingHeadersModel

  return {
    deviceInfo,
    browserInfo,
    systemType,
    systemVersion,
    trackingHeaders,
  }
})
